import Image from 'app/Components/Shared/Image/image';
import BusinessInvoicesContext from 'app/Components/Page/BusinessInvoicesPage/BusinessInvoicesContext';
import React, {memo, useContext} from 'react';
import classNames from 'classnames';

const ProviderNames = [`${window.Config.brand_Name_HE}`, "נטויז'ן", `${window.Config.brand_Name_HE} ונטויז׳ן`];

const BusinessInvoicesSearchCollapsed = () => {
  const [{selected, search, collapsed}, dispatch] = useContext(BusinessInvoicesContext);
  return selected == null || search == null ? null : (
    <div
      className={classNames('BusinessInvoicesSearchCollapsed', {collapsed})}
      onClick={() => dispatch({type: 'collapsed', collapsed: false})}>
      <Image className='BusinessInvoicesSearchCollapsed__icon' src={require('./images/icons-search.svg')} />
      <div className='BusinessInvoicesSearchCollapsed__col'>
        <div className='BusinessInvoicesSearchCollapsed__col__key'>ח"פ</div>
        <div className='BusinessInvoicesSearchCollapsed__col__value'>{selected?.idNumber}</div>
      </div>
      <div className='BusinessInvoicesSearchCollapsed__col'>
        <div className='BusinessInvoicesSearchCollapsed__col__key'>ספק</div>
        <div className='BusinessInvoicesSearchCollapsed__col__value'>{ProviderNames[search?.invoiceOrigin]}</div>
      </div>
      <div className='BusinessInvoicesSearchCollapsed__col'>
        <div className='BusinessInvoicesSearchCollapsed__col__key'>חודשים</div>
        <div className='BusinessInvoicesSearchCollapsed__col__value'>{search?.invoiceCount}</div>
      </div>
      <Image className='BusinessInvoicesSearchCollapsed__icon' src={require('./images/icons-sort-arrow-select.svg')} />
    </div>
  );
};

export default memo(BusinessInvoicesSearchCollapsed);
